import React from 'react';
import { Bot, Sparkles } from 'lucide-react';
import { Chat } from './Chat';
import { PageTitle } from '../../../_metronic/layout/core';

type Props = {
  className?: string;
};

const AIScreen: React.FC<Props> = () => {
  return (
    <div className="bg-gray-50">
      <PageTitle>Compra AI - Inteligência Artificial</PageTitle>
      <div className="mx-auto">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700 flex items-center justify-between">
            <div className="flex items-center">
              <div className="p-2 bg-white/15 rounded-xl backdrop-blur-sm">
                <Bot className="w-6 h-6 text-white" />
              </div>
              <div className="ml-4">
                <h1 className="text-lg font-semibold text-white">
                  Compra AI
                </h1>
                <p className="text-sm text-white/80">
                  Assistente virtual para suporte e consultas
                </p>
              </div>
            </div>
            
          </div>

          <Chat />
        </div>
      </div>
    </div>
  );
};

export default AIScreen;
